import {Howl} from 'howler'
import * as CSS from 'utils/css.js'
import * as Utils from 'utils/math.js'
import TweenMax from 'gsap'
import Emitter from 'core/Emitter'
import Detector from 'utils/Detector'
let instance = null

export default class SoundManager {
  constructor (opts) {
    if (!instance) {
      instance = this
      this.soundSprites = opts.soundSprites
      this.spriteMap = opts.spriteMap
      // this.spriteMap = Object.values(opts.spriteMap)

      this.introFirstPlay = true
      this.ambientIsPlaying = false
      this.isMobile = Detector.isMobile()
      this.howler = null
      this.sounds = []
      this.bindAll()
      this.init()
      this.playingSounds = []
      this.muted = false
      this.mutedAll = false
      this.flowerOverSpriteId = -1
    }
    return instance
  }

  addListeners () {
    Emitter.on('SOUND::PLAYINIT', this.playInitSounds)
    Emitter.on('SOUND::PLAY_FLOWER_OVER', this.playFlowerOverSounds)
    Emitter.on('SOUND::STOP_FLOWER_OVER', this.stopFlowerOverSounds)
    Emitter.on('SOUND::PLAY_FLOWER_CLICK', this.playFlowerClickSounds)
    Emitter.on('SOUND::PLAY_UI_CLICK', this.playUIClickSound)
    Emitter.on('SOUND::PLAY_NAV_CLICK', this.playNavClickSounds)

    Emitter.on('SOUND::TOGGLE_SOUND', this.toggleSound)
  }

  removeListeners () {
    Emitter.removeListener('SOUND::PLAYINIT', this.playInitSounds)
    Emitter.removeListener('SOUND::PLAY_FLOWER_OVER', this.playFlowerOverSounds)
    Emitter.removeListener('SOUND::STOP_FLOWER_OVER', this.stopFlowerOverSounds)
    Emitter.removeListener('SOUND::PLAY_FLOWER_CLICK', this.playFlowerClickSounds)
    Emitter.removeListener('SOUND::PLAY_UI_CLICK', this.playUIClickSound)
    Emitter.removeListener('SOUND::PLAY_NAV_CLICK', this.playNavClickSounds)

    Emitter.removeListener('SOUND::TOGGLE_SOUND', this.toggleSound)
  }

  initSounds () {
    let mergeSprite = Object.assign({}, this.spriteMap.core, this.spriteMap.flowerOver, this.spriteMap.flowerClick, this.spriteMap.uiClick, this.spriteMap.navClick)
    this.sounds = new Howl({
      src: [this.soundSprites],
      format: ['mp3'],
      sprite: mergeSprite,
      volume: 1,
      onload: () => {
        this.soundsLoaded = true
        this.playInitSounds()
      }
    })
    this.soundsPlayback = new Howl({
      src: [this.soundSprites],
      format: ['mp3'],
      sprite: mergeSprite,
      volume: 1
    })
    this.sounds.on('fade', this.onFade)
  }

  init () {
    this.addListeners()
    this.initSounds()
  }

  playInitSounds (params) {
    if (this.soundsLoaded && this.isIntro === undefined) return

    if (params) this.isIntro = params.intro

    if (!this.soundsLoaded) return

    if (this.isIntro && this.introFirstPlay) {
      this.playingSounds.intro = []
      this.playingSounds.intro.id = this.sounds.play('intro')
      this.playingSounds.intro.volume = this.muteAll ? 0 : 0.5
      this.sounds.volume(this.playingSounds.intro.volume, this.playingSounds.intro.id)
      this.introFirstPlay = false
    }

    if (!this.ambientIsPlaying) {
      this.playingSounds.ambient = []
      this.playingSounds.ambient.id = this.sounds.play('ambient')
      this.playingSounds.ambient.volume = this.muteAll ? 0 : 0.2
      this.sounds.volume(this.playingSounds.ambient.volume, this.playingSounds.ambient.id)
      this.ambientIsPlaying = true
    }
  }

  playFlowerOverSounds () {
    if (this.muteAll) return
    if (this.playingSounds.flowerOver && this.sounds.playing(this.playingSounds.flowerOver.id)) {
      this.playingSounds['flowerOver--playback'] && this.soundsPlayback.stop(this.playingSounds['flowerOver--playback'])
      this.playingSounds['flowerOver--playback'] = this.soundsPlayback.play(this.playingSounds.flowerOver.spriteName)
      // this.soundsPlayback.fade(0.8, 0.0, 800, this.playingSounds['flowerOver--playback'])
      let currentPos = this.sounds.seek(this.playingSounds.flowerOver.id)
      this.soundsPlayback.seek(currentPos, this.playingSounds['flowerOver--playback'])
      this.soundsPlayback.fade(this.sounds.volume(this.playingSounds.flowerOver.id), 0, 800, this.playingSounds['flowerOver--playback'])

      this.sounds.stop(this.playingSounds.flowerOver.id)
    }
    this.playSounds('flowerOver')
  }

  stopFlowerOverSounds () {
    if (this.muteAll) return
    if (this.soundsPlayback.playing(this.playingSounds['flowerOver--playback'])) {
      this.sounds.fade(this.sounds.volume(this.playingSounds.flowerOver.id), 0, 800, this.playingSounds.flowerOver.id)
    }
  }

  playFlowerClickSounds () {
    this.playSounds('flowerClick')
  }

  // Joue les son de click
  playUIClickSound () {
    this.playSounds('uiClick')
  }

  // Joue les sons au click des btn nav sur la page single-plant
  playNavClickSounds ({direction}) {
    let directionSprite = direction === 'prev' ? 1 : 0
    this.playSounds('navClick', directionSprite)
  }

  playSounds (spriteType, spriteId, randomVol) {
    if (this.muteAll) return
    this.playingSounds[spriteType] = []
    this[`${spriteType}Id`] = this[`${spriteType}Id`] || -1
    let sprite = spriteId === undefined ? this.getRandomSprite(this[`${spriteType}Id`], spriteType) : spriteId
    this.playingSounds[spriteType].spriteName = Object.keys(this.spriteMap[spriteType])[sprite]
    this.playingSounds[spriteType].id = this.sounds.play(this.playingSounds[spriteType].spriteName)
    this.flowerOverSpriteId = sprite

    if (randomVol) {
      this.playingSounds[spriteType].volume = Math.floor(Math.random() * (this.spriteMap.volume[spriteType] - 0.1)) + 0.1
    } else {
      this.playingSounds[spriteType].volume = this.spriteMap.volume[spriteType]
    }
    this.sounds.volume(this.playingSounds[spriteType].volume, this.playingSounds[spriteType].id)
  }

  fadeIntro (volume) {
    if (!this.playingSounds.intro) return
    this.playingSounds.intro.volume = volume
    if (this.muteAll) return
    if (this.mutedFade) return
    this.sounds.volume(this.playingSounds.intro.volume, this.playingSounds.intro.id)
  }

  toggleSound (params) {
    if (params.sender === 'toggleSound') {
      this.muteAll = !params.muted
    }
    if (this.muteAll && params.sender !== 'toggleSound') return
    this.muted = !params.muted
    this.toggle = true
    // this.sounds.mute(!hasFocus)
    // this.soundsPlayback.mute(!hasFocus)
    // if (hasFocus) {
    //   console.log('SOUND UNMUTED !!')
    //   TweenMax.to(this.sounds, 2, {
    //     volume: 0.5,
    //     ease: Expo.easeOut
    //   })
    // } else {
    //   console.log('SOUND MUTED --')
    //   let volume = this.sounds.volume()
    //   this.sounds.fade(volume, 0, 2000)
    //   this.soundsPlayback.fade(volume, 0, 2000)
    // }

    for (var i = 0; i < this.sounds._sounds.length; i++) {
      let sound = this.sounds._sounds[i]
      if (!sound._ended) {
        let spriteName = this.playingSounds[sound._sprite] ? sound._sprite : sound._sprite.substring(0, sound._sprite.length - 1)
        let volumeDest = params.muted ? this.playingSounds[spriteName].volume : 0
        let volumeStart = params.muted ? 0 : this.playingSounds[spriteName].volume
        this.sounds.fade(volumeStart, volumeDest, 1300, sound._id)
      }
    }
  }

  onFade (idSound) {
    if (this.toggle && this.muted) {
      this.mutedFade = true
    } else if (this.toggle) {
      this.mutedFade = false
    }
    this.toggle = false
    // console.log(' ON FADE ', idSound, this.playingSounds.length)
    // for (var i = 0; i < this.playingSounds.length; i++) {
    //   console.log('IDSOUND:' + idSound + ' ID:' + this.playingSounds[i])
    //   if (this.playingSounds[i] === idSound) {
    //     this.playingSounds[i] = false
    //   }
    // }
  }
  getRandomSprite (previousSprite, spriteType) {
    if (Object.keys(this.spriteMap[spriteType]).length === 1) { return 0 }
    let randomSprite
    do {
      randomSprite = Math.round(Math.random() * (Object.keys(this.spriteMap[spriteType]).length - 1))
    } while (randomSprite === this.flowerOverSpriteId)
    return randomSprite
  }

  destroy () {
    this.removeListeners()
  }

  bindAll () {
    [
      'playInitSounds',
      'playFlowerOverSounds',
      'stopFlowerOverSounds',
      'onFade',
      'playFlowerClickSounds',
      'toggleSound',
      'playUIClickSound',
      'playNavClickSounds'
    ].forEach((fn) => (this[fn] = this[fn].bind(this)))
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/SoundManager.js
 **/